import React from 'react';
export const LegendReleaseLevelIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg
    width={24}
    height={18}
    viewBox="0 0 24 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2.5" width="19" height="18" rx="4" fill="#E9E9E9" />
    <path
      d="M11.593 13H7.446C7.38 13 7.358 12.967 7.358 12.901V5.828C7.358 5.784 7.369 5.751 7.424 5.751H8.37C8.414 5.751 8.436 5.773 8.436 5.817V12.021H11.769C11.835 12.021 11.846 12.054 11.835 12.098L11.681 12.923C11.67 12.989 11.637 13 11.593 13ZM14.0051 9.81H13.4661C13.4221 9.81 13.3891 9.788 13.3891 9.744V8.93C13.3891 8.875 13.4001 8.842 13.4551 8.842H13.9171C14.8191 8.842 15.3581 8.512 15.3581 7.874C15.3581 7.291 14.9511 6.862 14.0491 6.862C13.4661 6.862 12.9821 7.005 12.4541 7.302C12.3991 7.324 12.3881 7.302 12.3881 7.258V6.444C12.3881 6.389 12.3881 6.367 12.4321 6.334C12.9161 6.07 13.5431 5.905 14.2361 5.905C15.6331 5.905 16.4141 6.664 16.4141 7.731C16.4141 8.567 15.8091 9.051 15.3251 9.227C15.9411 9.381 16.7661 9.876 16.7661 10.987C16.7661 12.351 15.6001 13.11 14.1151 13.11C13.4001 13.11 12.7841 12.989 12.3111 12.725C12.2671 12.703 12.2561 12.659 12.2561 12.604V11.713C12.2561 11.669 12.3001 11.658 12.3331 11.68C12.9271 11.999 13.4551 12.153 14.0821 12.153C15.2151 12.153 15.6661 11.614 15.6661 10.976C15.6661 10.184 15.0281 9.81 14.0051 9.81Z"
      fill="#292929"
    />
  </svg>
);
